module.exports = __webpack_public_path__ + "img/RML_logo.350ed3ba.png";